<template>
  <div :style="`height:calc(100vh - ${minusHeight}px)`">
    <div :id="`${randomId}`"></div>
  </div>
</template>

<script>
import { TOKEN_KEY } from "@/libs/util";
import Cookies from "js-cookie";

var DocsAPI = window.DocsAPI;
var docEditor;
// var innerAlert = function(message) {
//   if (console && console.log) console.log(message);
// };
import { editorFileInfo } from "@/api/media";

export default {
  name: "editorComponent",
  props: {
    fileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    }
  },
  data() {
    return {
      resBaseUrl: "https://res.gosmart.mn/",
      actionURL: "",
      fileName: "",
      fileType: "",
      fileUrl: "",
      key: "",
      vkey: "",
      callbackUrl: "",
      documentType: "",
      randomId: ""
    };
  },
  mounted() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.resBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }

    this.randomId = "docpreview_" + this.makeid(10);
    if (this.fileId != undefined) {
      editorFileInfo({ params: { id: this.fileId }, store: this.$store }).then(
        res => {
          if (res != false) {
            this.fileName = res.data.file.fileName;
            this.fileType = res.data.file.extension;
            this.callbackUrl =
              res.data.file.callbackUrl +
              "&access_token=" +
              Cookies.get(TOKEN_KEY);
            this.fileUrl = res.data.file.url;
            this.key = res.data.file.key;
            this.vkey = res.data.file.vkey;
            this.documentType = res.data.file.documentType;
            this.init();
          }
        }
      );
    }
  },
  methods: {
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    },
    onReady() {
      //innerAlert("Document editor ready");
    },
    onRequestHistoryClose(event) {
      //console.log(event);
      document.location.reload();
    },
    onDocumentStateChange(event) {
      var title = document.title.replace(/\*$/g, "");
      document.title = title + (event.data ? "*" : "");
      // document.title = event.data;
    },
    onRequestEditRights() {
      if (typeof DocsAPI.DocEditor.version == "function") {
        var version = DocsAPI.DocEditor.version();

        if ((parseFloat(version) || 0) >= 3) {
          location.href = location.href.replace(
            RegExp("action=view&?", "i"),
            ""
          );
          return;
        }
      }
      docEditor.applyEditRights(true);
    },

    init() {
      let self = this;
      this.$nextTick(() => {
        docEditor = new DocsAPI.DocEditor(this.randomId, {
          width: "100%",
          height: "100%",
          type: this.$store.state.app.isMobile ? "mobile" : "embedded",
          documentType: this.documentType,
          document: {
            title: this.fileName,
            url: this.fileUrl,
            fileType: this.fileType,
            key: this.key,
            vkey: this.vkey,

            info: {
              author: "Dynamic platform",
              created: "2021-04-15"
            },

            permissions: {
              edit: false,
              download: false,
              print: false
            }
          },
          editorConfig: {
            mode: "view",
            lang: "en-EN",
            callbackUrl: this.callbackUrl,
            user: {
              id: "36bae620-6f89-47f4-8333-ed280cbe2923",
              firstname: "Dynamic Platform",
              lastname: ""
            },
            embedded: {
              saveUrl: "",
              toolbarDocked: "bottom"
            },
            customization: {
              zoom: 100,
              logo: {
                image: self.resBaseUrl + "media/logo/logo.png",
                imageEmbedded: self.resBaseUrl + "media/logo/logo.png?w=100",
                url: "http://www.gosmart.mn"
              },
              backgroundColor: "#000",
              textColor: "#000",
              customer: {
                name: "Динамик Оффис",
                address: "Монгол улс, Улаанбаатар хот",
                mail: "gosmartmn@gmail.com",
                www: "www.gosmart.mn",
                info: "Gosmart TM LLC",
                logo: self.resBaseUrl + "media/logo/logo.png?"
              },
              about: false,
              feedback: {
                visible: false,
                url: "http://www.gosmart.mn"
              },
              goback: {
                visible: false,
                text: "Идэвхтэй цонхыг хаана уу",
                url: "" //"http://api.gosmart.mn/media/explorer"
              },
              chat: true,
              comments: true
            }
          },
          events: {
            onReady: this.onReady,
            onDocumentStateChange: this.onDocumentStateChange,
            onRequestEditRights: this.onRequestEditRights,
            onError: this.onError,
            //"onCollaborativeChanges": onCollaborativeChanges,
            //"onRequestHistory": onRequestHistory,
            //"onRequestHistoryData": onRequestHistoryData,
            onRequestHistoryClose: this.onRequestHistoryClose
          }
        });
      });
    }
  }
};
</script>
